var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBadger(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128 256C57.3075 256 0 198.692 0 128C0 57.3075 57.3075 0 128 0C198.692 0 256 57.3075 256 128C256 198.692 198.692 256 128 256ZM200.301 99.3139V93.1699H200.3V74.5137H206.427V61.9114H200.307V61.9066H206.427H206.428V55.5082H206.427H200.293V43.2691H175.254V49.376H162.638H162.637H156.486H143.639H112.442H106.04H93.4438H80.827V43.2691H55.7876V55.5082H49.6539V61.9066H55.7742V61.9114H49.6539V74.5137H55.7807V93.1699V99.3139H49.6539V105.788H43.52V143.448H49.6539V155.706H55.7706V161.847H62.1759V168.306H62.1824H68.3064V174.703H74.7748V180.837H74.778H80.9119V185.176L80.9115 187.238H80.9119V187.24H87.0385V193.094H87.0392V193.096H93.44L93.4413 199.567H99.5712V205.962V218.497H106.04V224.695H112.445V231.092V231.094H118.565H137.516H143.636V231.092V224.695H150.042V218.497H156.509V205.962V199.567H162.639H162.641V193.096H169.042V187.24H175.169V180.837H181.302H181.303H181.306V174.703H187.775V168.306H193.897H193.898H193.905V161.847H200.31V155.706H206.427V143.448H212.561V105.788H206.427V99.3139H200.301Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadger);
export default __webpack_public_path__ + "static/media/badger.c6ca597c.svg";
export { ForwardRef as ReactComponent };